import useFetch from '../../../hooks/useFetch';
import { WarehouseQuoteStorageDataForm, WarehouseQuoteStorageFilters } from '../../models/WareHouseQuoteStorage';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';

const useWarehouseStorageService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingUpdateWarehouseStorage, setFetchingUpdateWarehouseStorage] = useState(false);
    const [fetchingGetWarehouseQuoteStorage, setFetchingGetWarehouseQuoteStorage] = useState(false);
    const [fetchingGetWarehouseQuoteStorages, setFetchingGetWarehouseQuoteStorages] = useState(false);
    const [fetchingStoreWarehouseQuoteStorage, setFetchingStoreWarehouseQuoteStorage] = useState(false);
    const [fetchingEditWarehouseQuoteStorage, setFetchingEditWarehouseQuoteStorage] = useState(false);
    const [fetchingCreateWarehouseQuoteStorage, setFetchingCreateWarehouseQuoteStorage] = useState(false);
    const [fetchingShowWarehouseQuoteStorage, setFetchingShowWarehouseQuoteStorage] = useState(false);
    const getWarehouseQuoteStorage = (quoteId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_STORAGE.replace(':quote_id', quoteId.toString()),
            setFetching: setFetchingGetWarehouseQuoteStorage
        });
    };

    const getAllWarehouseQuoteStoragesByQuote = (
        quoteId: number,
        storageFilters: WarehouseQuoteStorageFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(storageFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_QUOTES.GET_ALL_WAREHOUSE_STORAGES}?${queryString}`;
        doGet({
            ...events,
            url: url.replace(
                ':quote_id',
                quoteId.toString()
            ),
            setFetching: setFetchingGetWarehouseQuoteStorages
        });
    };

    const showWarehouseQuoteStorage = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.SHOW_WAREHOUSE_STORAGE.replace(':id', id.toString()),
            setFetching: setFetchingShowWarehouseQuoteStorage
        });
    };

    const editWarehouseStorage = (
        quoteId: number,
        events: ServiceEvents = {}
    ) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.EDIT_WAREHOUSE_STORAGE.replace(':id', quoteId.toString()),
            setFetching: setFetchingEditWarehouseQuoteStorage
        
        
        });
    };


    const createWarehouseQuoteStorage = (
        quoteId: number,
        events: ServiceEvents = {}
    ) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.CREATE_WAREHOUSE_STORAGE.replace(':quote_id', quoteId.toString()),
            setFetching: setFetchingCreateWarehouseQuoteStorage
        });
    };

    const storeWarehouseQuoteStorage = (
        data: WarehouseQuoteStorageDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.STORE_WAREHOUSE_STORAGE,
            body: data,
            setFetching: setFetchingStoreWarehouseQuoteStorage
        });
    };

    const updateWarehouseStorage = (
        id: number,
        data: WarehouseQuoteStorageDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.UPDATE_WAREHOUSE_STORAGE.replace(':id', id.toString()),
            body: data,
            setFetching: setFetchingUpdateWarehouseStorage
        });
    };

    const deleteWarehouseQuoteStorage = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.DELETE_WAREHOUSE_STORAGE.replace(':id', id.toString())
        });
    };




    return {
        getWarehouseQuoteStorage,
        getAllWarehouseQuoteStoragesByQuote,
        showWarehouseQuoteStorage,
        storeWarehouseQuoteStorage,
        updateWarehouseStorage,
        deleteWarehouseQuoteStorage,
        editWarehouseStorage,
        createWarehouseQuoteStorage,
        fetchingCreateWarehouseQuoteStorage,
        fetchingGetWarehouseQuoteStorage,
        fetchingGetWarehouseQuoteStorages,
        fetchingStoreWarehouseQuoteStorage,
        fetchingUpdateWarehouseStorage,
        fetchingEditWarehouseQuoteStorage,
        fetchingShowWarehouseQuoteStorage
    };
};

export default useWarehouseStorageService;
